import PropTypes from 'prop-types';
import React from 'react';

import FormManager from '../../../../gd-form/common/form-manager';

import Input from '../../../../gd-form/form-element/input/input.jsx';
import ButtonSubmitDeprecated from 'core/gd-form/common/btn-submit/btn-submit.tsx';
import Button from 'gd-comp-button';

class ModalGoogleDriveAddFolder extends React.Component {
    static propTypes = {
        onAddFolder: PropTypes.func,
        onCancel: PropTypes.func
    };

    UNSAFE_componentWillMount() {
        const initFormData = {
            title: ''
        };

        const formStructure = {
            fields: {
                title: {
                    type: 'input',
                    isRequired: true
                }
            },
            onSubmit: this.onSubmit
        };

        this.form = new FormManager(formStructure, initFormData);
    }

    onSubmit = (result) => {
        const { onAddFolder } = this.props;
        if (onAddFolder) onAddFolder(result);
    };

    onCancel = () => {
        const { onCancel } = this.props;
        if (onCancel) onCancel();
    };

    render() {

        return (
            <div className="main-body add-folder">
                <Input ref="title_input"
                       className="folder-name"
                       form={this.form}
                       name="title"
                       size="big"
                       placeholder="Folder name"
                       hidePlaceholderOnFocus={false}/>
                <ButtonSubmitDeprecated className="add-button" form={this.form} label="Create"/>
                <Button className="cancel-button" onClick={this.onCancel} label="Cancel"/>
            </div>
        );
    }
}

module.exports = ModalGoogleDriveAddFolder;